<div class="feature-area overflow-hidden my-2" id="feature-area">
    <div class="row gx-0 justify-content-center">
        <div class="col-xl-4 col-lg-6">
            <div class="feature-item d-flex align-items-start">
                <div class="feature-item_icon">
                    <img src="assets/img/icon/feature_1_1.svg" alt="icon">
                </div>
                <div class="media-body">
                    <h3 class="box-title text-anime-style-2">Highly Expert Team</h3>
                    <p class="feature-item_text wow fadeInUp">We provide the most responsive and functional IT design
                    </p>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-6">
            <div class="feature-item d-flex align-items-start">
                <div class="feature-item_icon">
                    <img src="assets/img/icon/feature_1_2.svg" alt="icon">
                </div>
                <div class="media-body">
                    <h3 class="box-title text-anime-style-2">24/7 Customer Service</h3>
                    <p class="feature-item_text">We provide the most responsive and functional IT design</p>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-lg-6">
            <div class="feature-item d-flex align-items-start">
                <div class="feature-item_icon">
                    <img src="assets/img/icon/feature_1_3.svg" alt="icon">
                </div>
                <div class="media-body">
                    <h3 class="box-title text-anime-style-2">Competitive Pricing</h3>
                    <p class="feature-item_text">We provide the most responsive and functional IT design</p>
                </div>
            </div>
        </div>
    </div>
</div>